"use client";

import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList>
        {menuItems.map(item => <NavigationMenuItem key={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group/link relative inline-flex items-center h-9 px-4 text-sm font-medium text-black transition-colors duration-200 hover:text-primary after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-200 after:ease-out hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  if (loading) {
    return <Button variant="ghost" size="icon" className="md:hidden" disabled>
        <Menu className="size-5" />
      </Button>;
  }
  return <>
      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
        {isOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {isOpen && <div className="absolute top-full left-0 right-0 bg-background border-t border-border shadow-medium md:hidden animate-fade-in-up">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-black hover:bg-accent hover:text-accent-foreground rounded-md transition-colors duration-200" onClick={() => setIsOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  return <header className="w-full bg-background border-b border-border sticky top-0 z-50 animate-fade-in-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/HomePage" className="flex items-center animate-fade-in-up">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/best_coffee_canada_logo_black.png" alt="Best Coffee Canada" className="h-7" />
          </Link>

          <MenuProvider menu_id="25" className="flex items-center animate-fade-in-up-delay-100">
            <HeaderMenuConsumer />
            <MobileMenuConsumer />
          </MenuProvider>

          <div className="flex items-center gap-2 animate-fade-in-up-delay-200">
            <Button asChild variant="outline" className="shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              <Link to="/">Home</Link>
            </Button>
            <Button asChild className="shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
              <Link to="/ContactPage">Get Started</Link>
            </Button>
          </div>
        </div>
      </div>
    </header>;
}